export const getSuccessNotificationMessage = (title: string, isEdit: boolean): string =>
  `${title} ${isEdit ? "updated" : "created"} successfully`;
